exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq-header[data-v-05be1956]{background:#f5f5f5}.faq-icon[data-v-05be1956]{color:#eb102f!important}.guidance-download-list[data-v-05be1956]{list-style-type:none}.primary-download[data-v-05be1956]{display:block;width:250px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-left:-24px;margin-bottom:12px}.primary-download[data-v-05be1956],.primary-icon[data-v-05be1956]{color:#eb102f!important}", ""]);

// exports
